import { render, staticRenderFns } from "./lookAll.vue?vue&type=template&id=d472185a&scoped=true"
import script from "./lookAll.vue?vue&type=script&lang=js"
export * from "./lookAll.vue?vue&type=script&lang=js"
import style0 from "./lookAll.vue?vue&type=style&index=0&id=d472185a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d472185a",
  null
  
)

export default component.exports